import type { ReactElement } from 'react';
import type { ConversationItem } from '@chatapp-inbox/shared';
import { useAssignConversation } from '../conversation';
import styles from './WriteNotice.module.css';

/**
 * No lugar do compositor quando a pessoa não pode responder (`canWrite` falso): sem responsável ela
 * pode assumir a conversa; com outra pessoa responsável só lê. Quem só lê nunca vê o botão.
 */
export function WriteNotice({ conversation }: { conversation: ConversationItem }): ReactElement {
  const { assign, pending, error } = useAssignConversation(conversation.id);
  const owner = conversation.assignedTo;

  if (owner) {
    return (
      <div className={styles.notice}>
        <p className={styles.text}>
          {`Esta conversa está com ${owner.name}. Só a pessoa responsável ou um administrador pode responder.`}
        </p>
      </div>
    );
  }

  return (
    <div className={styles.notice}>
      <p className={styles.text}>Assuma esta conversa para responder.</p>
      <button
        type="button"
        className={styles.assume}
        // `aria-disabled` e não `disabled`: o botão focado não pode perder o foco durante o pedido.
        aria-disabled={pending || undefined}
        onClick={() => {
          if (!pending) assign();
        }}
      >
        {pending ? 'Assumindo…' : 'Assumir conversa'}
      </button>
      {/* A região existe antes do erro, para o leitor de tela anunciá-lo quando chegar. */}
      <p role="alert" className={styles.error}>
        {error}
      </p>
    </div>
  );
}
